import React, { useState } from 'react';
import { Link } from 'react-router';
import logo from '../../assets/logo1.webp'; // Update the path to the logo image
import './Header.css';

function Header() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <header className="App-header">
            <img src={logo} className="App-photo wide-logo" alt="Your Name" />
            <div className="hamburger" onClick={toggleMenu}>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
            <nav className={`nav ${isOpen ? 'open animated' : ''}`}>
                <Link to="/about">About</Link>
                <Link to="/projects">Projects</Link>
                <Link to="/schedule">Schedule</Link>
                <Link to="/comment">Comment</Link>
                <Link to="/contact">Contact</Link>
            </nav>
        </header>
    );
}

export default Header;
